var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.tenants,"items-per-page":10},scopedSlots:_vm._u([{key:"item.startDate",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("moment")(item.startDate,"Do MMMM YYYY"))+" ")]}},{key:"item.endDate",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("moment")(item.endDate,"Do MMMM YYYY"))+" ")]}},{key:"item.rent",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatRent(item.rent))+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }